import { render, staticRenderFns } from "./Overview4.vue?vue&type=template&id=601bf2f6&scoped=true"
import script from "./Overview4.vue?vue&type=script&lang=js"
export * from "./Overview4.vue?vue&type=script&lang=js"
import style0 from "./Overview4.vue?vue&type=style&index=0&id=601bf2f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601bf2f6",
  null
  
)

export default component.exports